import { DialRiskLevel } from '../fire-alarm-system';
import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';
import { ActivationRegimeCase } from './activation-regime/activation-regime.dto';

export class IntegrationCommandPostDto extends InspectionCase {
  dialRiskLevel?: DialRiskLevel;
  commandPostLocation?: InspectionValueCase;
  commandPostParts?: InspectionCase;
  installedSystems?: InspectionCase;
  performedActions?: ActivationRegimeCase;
  manualActions?: InspectionCase;
}

export class IntegrationCommandPost extends IntegrationCommandPostDto {
  constructor(
    data: IntegrationCommandPostDto = {
      title: 'הערות נוספות על ידי המעבדה',
      isApplicable: true
    }
  ) {
    super(data);
    this.dialRiskLevel = new DialRiskLevel({
      ...data.dialRiskLevel,
      title: 'החייגן האוטומטי'
    });
    this.commandPostLocation = new InspectionValueCase({
      ...data.commandPostLocation,
      title: 'עמדת פיקוד כבאים ממוקמת'
    });
    this.commandPostParts = new InspectionCase({
      ...data.commandPostParts,
      title: 'בעמדת פיקוד כבאים מותקנים'
    });
    this.installedSystems = new InspectionCase({
      ...data.installedSystems,
      title: 'במבנה מותקנות מערכות'
    });
    this.performedActions = new ActivationRegimeCase({
      ...data.performedActions,
      title: 'אזעקת אש כתוצאה מהפעלות'
    });
    this.manualActions = new InspectionCase({
      ...data.manualActions,
      title: 'הפעלות ידניות בפנלי הכבאים'
    });
  }

  setInspectionStatus(): void {
    this.dialRiskLevel.setInspectionStatus();
    this.performedActions.setInspectionStatus();
    this.isPassed =
      !this.isApplicable ||
      ((!this.dialRiskLevel.isApplicable || this.dialRiskLevel.isPassed) &&
        (!this.commandPostLocation.isApplicable ||
          this.commandPostLocation.isPassed) &&
        (!this.commandPostParts.isApplicable ||
          this.commandPostParts.isPassed) &&
        (!this.installedSystems.isApplicable ||
          this.installedSystems.isPassed) &&
        (!this.performedActions.isApplicable ||
          this.performedActions.isPassed) &&
        (!this.manualActions.isApplicable || this.manualActions.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.dialRiskLevel.getNotes(),
      ...this.commandPostLocation.getNotes(),
      ...this.commandPostParts.getNotes(),
      ...this.installedSystems.getNotes(),
      ...this.performedActions.getNotes(),
      ...this.manualActions.getNotes()
    ];
  }
}
